// extracted by mini-css-extract-plugin
export default {"header":"Header_header__zxPgm","icon":"Header_icon__ckmiB"};